import { endpoints } from 'modules/endpoints'
import { createBasicManagers } from 'modules/utils/helpers/createBasicManagers'
import { octopusApiClient } from 'modules/utils/httpClient'
import { ListResponse } from 'types/api'
import {
  TargetSkuListRequestFilter,
  TargetSkuListRequestSorting,
  TargetSkuUpdateDTO,
  PedigreedGrowerTargetSku,
  PedigreedGrowerTargetSkuCreateDTO,
} from '../common/types'

const pedigreedGrowerTargetSkuManagers = {
  ...createBasicManagers<
    TargetSkuListRequestFilter,
    TargetSkuListRequestSorting,
    PedigreedGrowerTargetSku,
    PedigreedGrowerTargetSkuCreateDTO,
    TargetSkuUpdateDTO
  >(endpoints.pedigreedGrowerTargetSku, octopusApiClient),
  getList: (
    filter: TargetSkuListRequestFilter,
    sorting: TargetSkuListRequestSorting,
    page: number,
    pageSize?: number,
  ) => {
    try {
      return octopusApiClient.get<ListResponse<PedigreedGrowerTargetSku>>(endpoints.pedigreedGrowerTargetSku(), {
        ...filter,
        ...sorting,
        page: page,
        page_size: pageSize,
        order_by: 'territory_asc',
      })
    } catch (err) {
      console.error('List fetch error!', err)
      throw err
    }
  },
}

export default pedigreedGrowerTargetSkuManagers
